export enum QualityOfMood { 
    Positive = 1,
    Negative = 3
    }